import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/data/handlers/base-service/base.service";
import { configApi } from "../../api-backend-multicountry/config/config.api";
import { countryConfig } from "src/country-config/country-config";
import { globalEnv } from "../../connection/global/global.env";
import { PropertyResponse } from "../../models/config/responses/property-res";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class ConfigService {

  constructor(
    private baseService: BaseService,
  ) {}

  getProperty<T>(objectID: string): Observable<T> {
    const endpoint = configApi.property
      .replace(':country', countryConfig.cctld)
      .replace(':objectID', objectID);
    const url = `${globalEnv.multiCountry}${endpoint}`;

    return this.baseService.get<PropertyResponse<T>>(url)
      .pipe(
        map((response: PropertyResponse<T>) => {
          if (!response?.data?.active) { return null; }

          return response?.data?.value;
        },
      ));
  }
}
